import {
  Button,
  Card,
  CardContent,
  DangerActionPanel,
  PageHeader,
  StatusChip,
  SwitchField,
} from "@jod/ui";
import { createFileRoute } from "@tanstack/react-router";
import { useConnectionToggle, useSocialPause, useStaffState } from "../../features/ops/queries.ts";

export const Route = createFileRoute("/_app/settings")({ component: SettingsScreen });

function SettingsScreen() {
  const { data } = useStaffState();
  const socialPause = useSocialPause();
  const toggleConnection = useConnectionToggle();
  return (
    <div className="space-y-6">
      <PageHeader
        title="Settings / ตั้งค่า"
        subtitle="Demo controls for offline/degraded states and emergency social disable."
      />
      {data ? (
        <>
          <Card>
            <CardContent className="space-y-4 p-5">
              <div className="flex gap-2">
                <StatusChip tone={data.connection.degraded ? "warning" : "success"}>
                  degraded: {String(data.connection.degraded)}
                </StatusChip>
                <StatusChip tone={data.connection.offline ? "danger" : "success"}>
                  offline: {String(data.connection.offline)}
                </StatusChip>
              </div>
              <SwitchField
                label="Connection degraded"
                description="Shows realtime/polling warning without silent success."
                checked={data.connection.degraded}
                onChange={() => toggleConnection.mutate("degraded")}
              />
              <SwitchField
                label="Offline simulation"
                description="Actions remain visible and reconcile when mock state returns."
                checked={data.connection.offline}
                onChange={() => toggleConnection.mutate("offline")}
              />
              <Button variant="outline" onClick={() => toggleConnection.mutate("degraded")}>
                Toggle degraded
              </Button>
            </CardContent>
          </Card>
          <DangerActionPanel
            title={
              data.session.socialPaused ? "Social features are paused" : "Emergency social disable"
            }
            description="Floor-manager-only in production. Ordering remains available; pending social interactions are voided in mock state."
            actionLabel={data.session.socialPaused ? "Re-enable social" : "Pause social"}
            onAction={() =>
              socialPause.mutate(
                data.session.socialPaused
                  ? { paused: false }
                  : { paused: true, reason: "Demo toggle from settings screen" },
              )
            }
          />
        </>
      ) : null}
    </div>
  );
}
